var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgError = function SvgError(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 12,
    "data-width-24": 18,
    "data-width-32": 24,
    viewBox: "0 0 11.9 11.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1.834 11.753A1.81 1.81 0 0 1 .26 10.86a1.83 1.83 0 0 1-.04-1.813L4.754.7A1.333 1.333 0 0 1 7.1.7l4.534 8.347a1.83 1.83 0 0 1-.04 1.813 1.81 1.81 0 0 1-1.574.893zM5.927 1a.33.33 0 0 0-.293.173L1.1 9.52a.83.83 0 0 0 0 .827.82.82 0 0 0 .714.406h8.206a.82.82 0 0 0 .714-1.233L6.22 1.173A.33.33 0 0 0 5.927 1m0 7.08a.507.507 0 0 1-.5-.5V3.96a.5.5 0 0 1 1 0v3.62a.507.507 0 0 1-.5.5m.66 1.227a.66.66 0 1 1-1.32 0 .66.66 0 0 1 1.32 0",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgError);
export default ForwardRef;